import { cn } from "@exhousing/design-system";

/** Pre-selection score 0–100 as a quiet banded meter: green >80, amber 60–80, red <60. */
export function ScoreMeter({
  score,
  className,
}: {
  score: number | null | undefined;
  className?: string;
}) {
  if (score == null) {
    return <span className={cn("text-xs text-muted-foreground", className)}>Not scored</span>;
  }
  const band =
    score > 80 ? "bg-emerald-500" : score >= 60 ? "bg-amber-500" : "bg-red-500";
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <span className="h-1.5 w-20 overflow-hidden rounded-full bg-muted">
        <span
          className={cn("block h-full rounded-full", band)}
          style={{ width: `${Math.max(2, Math.min(100, score))}%` }}
        />
      </span>
      <span className="text-sm font-medium tabular-nums">{score}</span>
    </span>
  );
}
